<template>
  <Layout>
    <PageHeader :title="title" :items="itemsPageHeader" />
    <b-row>
      <b-col>
        <b-card title="Details">
          <b-table-simple responsive>
            <b-tbody>
              <b-tr>
                <b-th style="min-width: 150px">id</b-th>
                <b-td>{{ item.id }}</b-td>
              </b-tr>
              <b-tr>
                <b-th>Date Time</b-th>
                <b-td>{{ FormatDateTimeFn(item.dateTime) }}</b-td>
              </b-tr>
              <b-tr>
                <b-th>Status</b-th>
                <b-td>
                  <div class="d-inline">
                    <span
                      class="label"
                      :class="[
                        item.status === 'Resent'
                          ? 'label-complete'
                          : 'label-pending',
                      ]"
                    >
                      {{ !item.status ? "None" : item.status }}
                    </span>
                  </div>
                  <div class="d-inline">
                    <b-button
                      v-if="
                        (item.status === 'None' || !item.status) &&
                        item.exchange
                      "
                      pill
                      class="ml-2"
                      variant="warning"
                      @click="onClickResend(item.id)"
                    >
                      <i class="fas fa-paper-plane"></i>ส่งอีกครั้ง
                    </b-button>
                    <b-button
                      disabled
                      v-if="item.status === 'Resent'"
                      pill
                      variant="success"
                      class="ml-2"
                    >
                      <i class="fas fa-check"></i>
                      {{ item.status === "Resent" ? "ส่งแล้ว" : item.status }}
                    </b-button>
                  </div>
                  <div class="d-inline ml-2" v-if="!item.exchange">
                    <i
                      class="h2 fas fa-exclamation-circle mb-0 text-warning"
                      id="tooltip-button-variant"
                    >
                    </i>
                    <b-tooltip target="tooltip-button-variant" variant="warning"
                      >ไม่สามารถส่งได้ เนื่องจากไม่มี Exchange</b-tooltip
                    >
                  </div>
                </b-td>
              </b-tr>
              <b-tr>
                <b-th>Routing Key</b-th>
                <b-td>23</b-td>
              </b-tr>
              <b-tr>
                <b-th>Exchange</b-th>
                <b-td>{{ item.exchange }}</b-td>
              </b-tr>
              <b-tr>
                <b-th>Queue</b-th>
                <b-td>{{ item.queue }}</b-td>
              </b-tr>
              <b-tr>
                <b-th>Exception</b-th>
                <b-td>{{ item.exception }}</b-td>
              </b-tr>
              <b-tr>
                <b-th>Message</b-th>
                <b-td>
                  <b-tooltip target="tooltip-target-1" triggers="hover">
                    {{ textTooltipCopy }}
                  </b-tooltip>
                  <b-button
                    size="sm"
                    variant="dark"
                    class="mb-3"
                    @click="doCopy(item.message || {})"
                    id="tooltip-target-1"
                  >
                    <i class="far fa-copy"></i> Copy All
                  </b-button>
                  <vue-json-pretty
                    v-if="item.message"
                    :data="JSON.parse(item.message || {})"
                  >
                  </vue-json-pretty>
                </b-td>
              </b-tr>
            </b-tbody>
          </b-table-simple>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-card title="BasicProperties">
          <p v-if="!basicProperties">No Content</p>
          <b-table-simple responsive small v-else>
            <b-tbody>
              <b-tr>
                <b-th>Content Type</b-th>
                <b-td>{{ basicProperties.contentType }}</b-td>
              </b-tr>
              <b-tr>
                <b-th>Content Encoding</b-th>
                <b-td>{{ basicProperties.contentEncoding }}</b-td>
              </b-tr>
              <b-tr>
                <b-th>Headers</b-th>
                <b-td>{{ basicProperties.headers }}</b-td>
              </b-tr>
              <b-tr>
                <b-th>Delivery Mode</b-th>
                <b-td>{{ basicProperties.deliveryMode }}</b-td>
              </b-tr>
              <b-tr>
                <b-th>Priority</b-th>
                <b-td>{{ basicProperties.priority }}</b-td>
              </b-tr>
              <b-tr>
                <b-th>Correlation Id</b-th>
                <b-td>{{ basicProperties.correlationId }}</b-td>
              </b-tr>
              <b-tr>
                <b-th>Reply To</b-th>
                <b-td>{{ basicProperties.replyTo }}</b-td>
              </b-tr>
              <b-tr>
                <b-th>Expiration</b-th>
                <b-td>{{ basicProperties.expiration }}</b-td>
              </b-tr>
              <b-tr>
                <b-th>Message Id</b-th>
                <b-td>{{ basicProperties.messageId }}</b-td>
              </b-tr>
              <b-tr>
                <b-th>Timestamp</b-th>
                <b-td>{{ basicProperties.timestamp }}</b-td>
              </b-tr>
              <b-tr>
                <b-th>Type</b-th>
                <b-td>{{ basicProperties.type }}</b-td>
              </b-tr>
              <b-tr>
                <b-th>User Id</b-th>
                <b-td>{{ basicProperties.userId }}</b-td>
              </b-tr>
              <b-tr>
                <b-th>App Id</b-th>
                <b-td>{{ basicProperties.appId }}</b-td>
              </b-tr>
              <b-tr>
                <b-th>Cluster Id</b-th>
                <b-td>{{ basicProperties.clusterId }}</b-td>
              </b-tr>
              <b-tr>
                <b-th>Content Type Present</b-th>
                <b-td>{{ basicProperties.contentTypePresent }}</b-td>
              </b-tr>
              <b-tr>
                <b-th>Content Encoding Present</b-th>
                <b-td>{{ basicProperties.contentEncodingPresent }}</b-td>
              </b-tr>
              <b-tr>
                <b-th>Headers Present</b-th>
                <b-td>{{ basicProperties.headersPresent }}</b-td>
              </b-tr>
              <b-tr>
                <b-th>Delivery Mode Present</b-th>
                <b-td>{{ basicProperties.deliveryModePresent }}</b-td>
              </b-tr>
              <b-tr>
                <b-th>Priority Present</b-th>
                <b-td>{{ basicProperties.priorityPresent }}</b-td>
              </b-tr>
              <b-tr>
                <b-th>Correlation Id Present</b-th>
                <b-td>{{ basicProperties.correlationIdPresent }}</b-td>
              </b-tr>
              <b-tr>
                <b-th>Reply To Present</b-th>
                <b-td>{{ basicProperties.replyToPresent }}</b-td>
              </b-tr>
              <b-tr>
                <b-th>Expiration Present</b-th>
                <b-td>{{ basicProperties.expirationPresent }}</b-td>
              </b-tr>
              <b-tr>
                <b-th>Message Id Present</b-th>
                <b-td>{{ basicProperties.messageIdPresent }}</b-td>
              </b-tr>
              <b-tr>
                <b-th>Timestamp Present</b-th>
                <b-td>{{ basicProperties.timestampPresent }}</b-td>
              </b-tr>
              <b-tr>
                <b-th>Type Present</b-th>
                <b-td>{{ basicProperties.typePresent }}</b-td>
              </b-tr>
              <b-tr>
                <b-th>User Id Present</b-th>
                <b-td>{{ basicProperties.userIdPresent }}</b-td>
              </b-tr>
              <b-tr>
                <b-th>App Id Present</b-th>
                <b-td>{{ basicProperties.appIdPresent }}</b-td>
              </b-tr>
              <b-tr>
                <b-th>Cluster Id Present</b-th>
                <b-td>{{ basicProperties.clusterIdPresent }}</b-td>
              </b-tr>
            </b-tbody>
          </b-table-simple>
        </b-card>
      </b-col>
    </b-row>
    <Loading :active.sync="isLoading" :is-full-page="fullPage"></Loading>
  </Layout>
</template>

<script>
// load components
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
// load config
import appConfig from "@/app.config";

//load helper
import { FormatQty } from "@/helpers/utils/format-qty.js";
import { FormatDate, FormatDateTime } from "@/helpers/utils/format-date.js";
import ModalMoreDetail from "@/components/consumer-logs/modal-more-detail.vue";
import core from "@/helpers/client";
import { ToISOString } from "@/helpers/utils/format-date.js";

// load package
import VueJsonPretty from "vue-json-pretty";
import "vue-json-pretty/lib/styles.css";

const axios = require("axios").default;

export default {
  name: "consumer_logs_detail",
  page: {
    title: "Consumer Log Detail",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    Loading,
    VueJsonPretty,
  },
  data() {
    return {
      isLoading: true,
      fullPage: true,
      title: "Consumer Log Detail",
      itemsPageHeader: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Consumer Log",
          active: true,
        },
      ],
      id: this.$route.params.id,
      item: {},
      basicProperties: {},
      textTooltipCopy: "Copy",
    };
  },
  mounted() {
    this.id = this.$route.params.id;
    this.isLoading = false;
    this.getConsumerLogByIDAsync();
  },
  methods: {
    async getConsumerLogByIDAsync() {
      this.isLoading = true;
      if (!this.id) {
        this.isLoading = false;
        return false;
      }
      const res = await core.fetch(
        `${process.env.VUE_APP_BASE_API_CONSUMER_LOG}/api/v1/ConsumerLog/${this.id}`
      );
      // console.log(res);
      if (res.status === 200) {
        this.item = res.data;
        this.basicProperties = res.data.basicProperties;
        this.isLoading = false;
      }
    },
    doCopy: function (message) {
      let vm = this;
      var text = message;
      navigator.clipboard.writeText(text).then(
        function () {
          console.log("Async: Copying to clipboard was successful!");
          vm.textTooltipCopy = "Copied!";
          setTimeout(() => {
            vm.textTooltipCopy = "Copy";
          }, 1000);
        },
        function (err) {
          console.error("Async: Could not copy text: ", err);
        }
      );
    },
    FormatDateTimeFn(val) {
      // console.log(val);
      return FormatDateTime(val);
    },
    async onClickResend(id) {
      const res = await core.create(
        `${process.env.VUE_APP_BASE_API_CONSUMER_LOG}/api/v1/ConsumerLog/${id}/RabbitMQ`,
        null
      );
      if (res.status === 200) {
        this.item.status = "Resent";
      }
    },
  },
};
</script>

<style scoped></style>
